// Dot-notation module names: "job.client.company" means "fetch the `job`
// module, then display the data found at `client.company` inside each record".
// Only the segment before the first dot is a real backend module — every API
// call (module-data-list, field-config, permissions) must use it, while the
// remaining segments are resolved client-side against each fetched record.

export function parseModulePath(moduleName) {
  const raw = String(moduleName ?? '').trim();
  if (!raw) return { baseModule: '', nestedPath: '' };

  const [baseModule, ...rest] = raw.split('.');
  return {
    baseModule: baseModule.trim(),
    nestedPath: rest.map((part) => part.trim()).filter(Boolean).join('.'),
  };
}

export function getBaseModuleName(moduleName) {
  return parseModulePath(moduleName).baseModule;
}

export function getValueAtPath(source, path) {
  return String(path ?? '')
    .split('.')
    .filter(Boolean)
    .reduce((value, key) => (value == null ? undefined : value[key]), source);
}
